import { render, staticRenderFns } from "./table_resetpass.vue?vue&type=template&id=fede8248&"
import script from "./table_resetpass.vue?vue&type=script&lang=js&"
export * from "./table_resetpass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports